import React, { ReactNode, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useReactiveVar } from '@apollo/client';

import { ContentWrapper } from '../../../../common/content-wrapper';
import { useStyles } from './about-profile.styles';
import { BackButton } from '../../../../common/back-button-new';
import { Page } from '../../page/page';
import image from '../../../../../assets/images/kids/kids-about.jpg';
import { AddProfile } from '../add-profile';
import { isAddDependentShow } from '../../../../../graphql/user/user.cache';

export const AboutProfile = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const items: string[] = useMemo(() => {
    return ['profileAbout.list-1', 'profileAbout.list-2', 'profileAbout.list-3', 'profileAbout.list-4'];
  }, []);
  const getText = useCallback((id: string) => {
    return intl.formatMessage(
      { id },
      { sup: (chunks: ReactNode) => <sup>{chunks}</sup>, noBreak: <>&nbsp;</> },
    );
  }, []);
  const isShowAdd = useReactiveVar(isAddDependentShow);

  return (
    <Page title={intl.formatMessage({ id: 'profileAbout.title' })}>
      <ContentWrapper>
        <div className={classes.root}>
          <BackButton />
          <h1 className={classes.title}>{intl.formatMessage({ id: 'profileAbout.title' })}</h1>
          <h2 className={classes.subtitle}>{getText('profileAbout.subtitle-1')}</h2>
          <p className={classes.text}>{getText('profileAbout.text-1')}</p>
          <p className={classes.text}>{getText('profileAbout.text-2')}</p>
          <img width={326} className={classes.img} src={image} alt="" />
          <h2 className={classes.subtitle}>{getText('profileAbout.subtitle-2')}</h2>
          <ul className={classes.list}>
            {items.map((item) => <li key={item}>{getText(item)}</li>)}
          </ul>
          {isShowAdd && (
            <div className={classes.button}>
              <AddProfile />
            </div>
          )}
        </div>
      </ContentWrapper>
    </Page>
  );
};
